<div mat-dialog-title class="justify-content-center align-items-center" style="margin-top: -10px !important;">
    <span *ngIf="!deleted && !error">¿Desea eliminar la muestra {{sample.labelId}}?</span>

    <mat-icon *ngIf="deleted && !error" style="color: green; font-size: 40px; height: 40px; width: 40px;" class="mr-3">done</mat-icon>
    <span *ngIf="deleted && !error">La operación se realizó correctamente  </span> 
    <mat-icon *ngIf="error" style="color: red; font-size: 40px; height: 40px; width: 40px;" class="mr-3">close</mat-icon>
    <span *ngIf="error"> Se produjo un error </span>
</div> 
<div mat-dialog-content *ngIf="!error && !deleted">
  <span *ngIf="profileTests.length > 0">También se van a borrar análisis contenidos en otra muestra:</span>
  <ul *ngIf="profileTests.length > 0">
      <li *ngFor="let test of profileTests">
          {{test.labelId}} - {{test.test.id}}
      </li>
  </ul>
</div>

  <div mat-dialog-footer>
    
  </div>

  <mat-dialog-actions align="center" >
      <ng-container *ngIf="!deleted && !error">
        <button mat-raised-button mat-dialog-close color="warn">No</button>
        <button mat-raised-button (click)="deleteOrder()" color="primary">Si</button>
      </ng-container>
      <ng-container *ngIf="error || deleted">
        <button mat-raised-button [mat-dialog-close]="deleted? true : false" color="primary">Cerrar</button>
      </ng-container>
    
    <!--button mat-raised-button [mat-dialog-close]="" (click) color="primary">Si</button-->

  </mat-dialog-actions>
